/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjects_Subject_Spanish15Inputs */

const en__field__enum_teachingsubjects_subject_spanish15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Spanish15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanish`)
};

const de__field__enum_teachingsubjects_subject_spanish15 = /** @type {(inputs: _Field__Enum_Teachingsubjects_Subject_Spanish15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spanisch`)
};

/**
* | output |
* | --- |
* | "Spanish" |
*
* @param {_Field__Enum_Teachingsubjects_Subject_Spanish15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjects_subject_spanish15 = /** @type {((inputs?: _Field__Enum_Teachingsubjects_Subject_Spanish15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjects_Subject_Spanish15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjects_subject_spanish15(inputs)
	return de__field__enum_teachingsubjects_subject_spanish15(inputs)
});
export { _field__enum_teachingsubjects_subject_spanish15 as "_field__enum_teachingSubjects_SUBJECT_SPANISH" }